<template>
  <fullscreen-modal
    id="mailingOverlay"
    @open="onOverlayOpen"
    @close="onOverlayClose"
  >
    <template slot="header">
      <step-indicator
        :step-index="stepIndex"
        @gotoStep="gotoStep"
      />
    </template>

    <component :is="currentStep" />
  </fullscreen-modal>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

import FullscreenModal from '@/components/app/FullscreenModal'
import StepHistory from '@/components/mailings/steps/History'
import StepTitle from '@/components/mailings/steps/Title'
import StepTags from '@/components/mailings/steps/Tags'
import StepArticles from '@/components/mailings/steps/Articles'
import StepRecipients from '@/components/mailings/steps/Recipients'
import StepSummary from '@/components/mailings/steps/Summary'
import StepSuccess from '@/components/mailings/steps/Success'
import StepIndicator from '@/components/mailings/MailingOverlayStepIndicator'

export default {
  components: {
    FullscreenModal,
    StepHistory,
    StepTitle,
    StepTags,
    StepArticles,
    StepRecipients,
    StepSummary,
    StepSuccess,
    StepIndicator
  },
  computed: {
    ...mapState({
      steps: state => state.mailing.step.entries,
      stepIndex: state => state.mailing.step.index
    }),
    ...mapGetters({
      currentStep: 'mailing/step/current'
    })
  },
  methods: {
    ...mapActions({
      fetchMailings: 'mailing/fetchEntries',
      gotoStep: 'mailing/step/setIndex',
      reset: 'mailing/entry/reset'
    }),
    onOverlayOpen () {
      this.fetchMailings(this.$route.params.folderId)
    },
    onOverlayClose () {
      this.gotoStep(0)
      this.reset()
    }
  }
}
</script>

<style lang="sass">

</style>



// WEBPACK FOOTER //
// src/components/mailings/MailingOverlay.vue